module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-ranger-picker"
  }, [_c('VueCtkRangeDatePicker', {
    attrs: {
      "format": _vm.format,
      "label": _vm.label,
      "range": true,
      "noLabel": true,
      "noHeader": false,
      "color": "#5EB9CF",
      "formatted": "ll"
    },
    model: {
      value: (_vm.internalValue),
      callback: function($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3ac5468!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/DateRangePicker.vue
// module id = 2622
// module chunks = 1